import { Controller } from "@hotwired/stimulus";

/**
 * Shows the hint text matching the currently-checked radio in a segmented
 * control. All hint nodes live in the DOM; we toggle `hidden` based on the
 * checked radio's value. No radio checked → all hints hidden.
 *
 * Usage:
 *   <div data-controller="radio-hint">
 *     <input type="radio" value="immediate"
 *            data-radio-hint-target="radio"
 *            data-action="change->radio-hint#update" />
 *     ...
 *     <span data-radio-hint-target="hint" data-mode="immediate" hidden>...</span>
 *     <span data-radio-hint-target="hint" data-mode="upon_acceptance" hidden>...</span>
 *   </div>
 */
export default class extends Controller {
  static targets = ["radio", "hint"];

  declare readonly radioTargets: HTMLInputElement[];
  declare readonly hintTargets: HTMLElement[];

  connect() {
    this.update();
  }

  update() {
    const checked = this.radioTargets.find((r) => r.checked);
    const mode = checked?.value;

    this.hintTargets.forEach((hint) => {
      hint.hidden = hint.dataset.mode !== mode;
    });
  }
}
